import script from "./CanvaPortal.vue?vue&type=script&setup=true&lang=js"
export * from "./CanvaPortal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__